import { Box, Slider, Typography } from "@mui/material";
import PhoneComponentLabel from "./PhoneComponentLabel";
import { ControlSlider } from "../../../../theme";
import { useState } from "react";
import { useRecoilState } from "recoil";
import { phoneWAtom, phoneHAtom } from "../../../../recoil/atoms";
import FaderThumbImage from "./../../../../assets/img/thumb_fader_20x10.png";
import LinearThumbImage from "./../../../../assets/img/thumb_linear_20x10.png";
import { EComponentType } from "../../../../common-interfaces/interfaces";

export default function SliderComponent(props: any) {
  const fontSize = Math.min(props.component.height, props.component.width) * 7;
  const [phoneW] = useRecoilState<number>(phoneWAtom);
  const [phoneH] = useRecoilState<number>(phoneHAtom);
  const [isLandscape] = useState(phoneW > phoneH);

  const H = props.component.height;
  const W = props.component.width;
  const thumbImg =
    props.component.type === EComponentType.Slider
      ? `url(${FaderThumbImage})`
      : `url(${LinearThumbImage})`;

  if (W >= H)
    return (
      <Box
        className="center col"
        sx={{ height: "100%" }}
        title={props?.component?.name?.toUpperCase()}
      >
        <Box
          height="30%"
          sx={{ textAlign: "center", paddingTop: "2,5%" }}
          className="center"
        >
          <PhoneComponentLabel
            component={props.component}
          ></PhoneComponentLabel>
        </Box>
        <Box
          className="center"
          sx={{
            height: isLandscape ? "70%" : "40%",
            width: "90%",
            px: 2,
            background: "#000",
            borderRadius: 1,
          }}
        >
          <ControlSlider
            step={1}
            min={0}
            max={100}
            sx={{
              "& .MuiSlider-thumb": {
                backgroundImage: thumbImg,
              },
            }}
          />
        </Box>
      </Box>
    );
  return (
    <Box
      className="center col"
      sx={{ height: "100%" }}
      title={props?.component?.name?.toUpperCase()}
    >
      <Box
        height="10%"
        sx={{ textAlign: "center", paddingTop: "2,5%" }}
        className="center"
      >
        <PhoneComponentLabel component={props.component}></PhoneComponentLabel>
      </Box>
      <Box
        className="center"
        sx={{
          height: "100%",
          mb: 2,
          width: isLandscape ? "20%" : "50%",
          background: "#000",
          py: 2,
          borderRadius: 1,
        }}
      >
        <ControlSlider
          orientation="vertical"
          step={1}
          min={1}
          max={10}
          sx={{
            "& .MuiSlider-thumb": {
              backgroundImage: thumbImg,
            },
          }}
        />
      </Box>
    </Box>
  );
}
